import { render, staticRenderFns } from "./FriendChat.vue?vue&type=template&id=83ceb0a6"
import script from "./FriendChat.vue?vue&type=script&lang=js"
export * from "./FriendChat.vue?vue&type=script&lang=js"
import style0 from "./FriendChat.vue?vue&type=style&index=0&id=83ceb0a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports